import { BREADCRUMB_NAV_TAB_MAP as tabMap } from "../../../constants/analyticsHeader";
import { PLOT_TYPE_OPTIONS as plotTypeOptions } from "../../../constants/visualizationOptions";

import React from "react";
import { Box, Breadcrumbs, Chip, Divider, Tooltip } from "@mui/material";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import Label from "../../../components/Label/Label";

import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { IconButton } from "@mui/material";
import { useNavigate } from "react-router-dom";

export default function BreadcrumbsBar({
  isUnitOpHide,
  showBack,
  onClickBack,
  selectedUnitOperations,
  sectionLabel,
}) {
  const location = useLocation();
  const navigate = useNavigate();

  const { unitOfOperation } = useSelector(
    (state) => state.shared.productSitesUopValues || {},
  );

  const pathSegments = location.pathname.split("/").filter(Boolean);

  // Check if last segment is a chart type
  const chartType =
    pathSegments.includes("charts") &&
    pathSegments[pathSegments.length - 1] !== "charts"
      ? pathSegments[pathSegments.length - 1]
      : null;

  const chartLabel =
    plotTypeOptions.find((opt) => opt.value === chartType)?.label || null;

  // Build breadcrumbs dynamically
  const crumbs = [
    { label: "SRM", color: "#717680" },
    ...pathSegments
      .map((seg) => {
        if (seg === "charts" && chartLabel) {
          return { label: chartLabel, color: "#717680" };
        }
        return tabMap[seg] ? { label: tabMap[seg], color: "#717680" } : null;
      })
      .filter(Boolean),
  ];

  // Append unitOfOperation crumb unless explicitly hidden or on restricted routes
  const hideUnitOpFor = ["reports", "create-report"];
  const hasSelectedUnitOperationsOverride = Array.isArray(
    selectedUnitOperations,
  );
  const selectedUnitOperationNames = hasSelectedUnitOperationsOverride
    ? selectedUnitOperations.map((item) => item?.name).filter(Boolean)
    : [];
  const unitOperationLabel = hasSelectedUnitOperationsOverride
    ? selectedUnitOperationNames.join(", ")
    : unitOfOperation?.name;
  const shouldShowUnitOp =
    !isUnitOpHide &&
    unitOperationLabel &&
    !pathSegments.some((seg) => hideUnitOpFor.includes(seg));

  if (sectionLabel) {
    crumbs.push({ label: sectionLabel, color: "#717680" });
  }

  if (shouldShowUnitOp) {
    crumbs.push({
      label: unitOperationLabel,
      color: "#154D8F",
      isUnitOperation: true,
    });
  }

  return (
    <Box px={3.5} py={1} display="flex" alignItems="center" gap={1}>
      {showBack && (
        <Chip
          icon={<ArrowBackIcon />}
          label="Back"
          onClick={onClickBack}
          clickable
          size="small"
          variant="filled"
          sx={{ padding: "0px 8px", fontSize: "12px" }}
        />
      )}

      <Breadcrumbs
        separator={<ArrowForwardIosIcon fontSize="small" />}
        aria-label="breadcrumb"
        sx={{
          minWidth: 0,
          maxWidth: "100%",
          "& .MuiBreadcrumbs-ol": { flexWrap: "nowrap" },
          "& .MuiBreadcrumbs-li": { minWidth: 0 },
        }}
      >
        {crumbs.map((crumb, idx) =>
          crumb.isUnitOperation ? (
            <Tooltip key={idx} title={crumb.label} placement="top" arrow>
              <Box
                component="span"
                sx={{
                  display: "block",
                  minWidth: 0,
                  maxWidth: { xs: "160px", sm: "300px", md: "450px" },
                  overflow: "hidden",
                }}
              >
                <Label
                  text={crumb.label}
                  color={crumb.color}
                  fontSize="12px"
                  fontWeight="500"
                  whiteSpace="nowrap"
                  overflow="hidden"
                  textOverflow="ellipsis"
                />
              </Box>
            </Tooltip>
          ) : (
            <Label
              key={idx}
              text={crumb.label}
              color={crumb.color}
              fontSize="12px"
              fontWeight="500"
            />
          ),
        )}
      </Breadcrumbs>
    </Box>
  );
}
